/**
 *Created by Heqi on 2018/1/18.
 */

// import { AbstractSearchArgument } from './global'
const FIELD_CONDITION = {
  wyDefaultValue: null,
  wyFChildCode: null,
  wyFChildName: null,
  wyFChildType: null,
  wyFCode: null,
  wyFName: null,
  wyFType: null,
  wyHasChild: false,
  wyUseDefault: false
}

export {
  FIELD_CONDITION
}



// WEBPACK FOOTER //
// ./src/models/ec-basic-field.js